export const checkRaceNames = (
  value: string,
  index: number,
  races: any,
  handleErrors: (prev: {}) => void
) => {
  let current = races[index];
  let otherRaces = [...races];
  otherRaces.splice(index, 1);

  const names = otherRaces.filter((r: { name: string; raceType: any }) => {
    if (r.name) {
      return (
        r.name === value &&
        (r.raceType === current?.raceType ||
          current?.raceType === "Non-Partisan")
      );
    }
    return false;
  });

  if (names?.length > 0) {
    handleErrors((prev: any) => ({
      ...prev,
      [`race-${index}`]: "Duplicate name",
    }));
  } else {
    handleErrors((prev: any) => {
      let prevErrors = prev;
      // @ts-ignore
      delete prevErrors[`race-${index}`];
      return { ...prevErrors };
    });
  }
};
